import mitt from 'mitt';
import { E_MIDDLEWARE_STEPS } from '../types/middlewares.types';
import stepsMiddleware from '../middlewares/steps.middleware';
import ExecutionDelay from 'execution-delay';
import { E_EDITOR_CUSTOM_EVENT } from '../types/custom-events.enums';
import type { IProductItems } from '../types/design-editor';
import type { E_TO_STEP_CUSTOM_EVENT } from '../types/steps.types';
import type { E_MODAL_CUSTOM_EVENT } from '../types/modals.enum';

type TEmitterEvents = {
  [E_EDITOR_CUSTOM_EVENT.SAVE_DESIGN]: void;
  [E_EDITOR_CUSTOM_EVENT.SAVE_DESIGN_SUCCESS]: string;
  [E_EDITOR_CUSTOM_EVENT.GET_PRODUCT_ITEMS]: void;
  [E_EDITOR_CUSTOM_EVENT.GET_PRODUCT_ITEMS_SUCCESS]: IProductItems;
  [E_EDITOR_CUSTOM_EVENT.EDITOR_LOAD]: void;
  [E_EDITOR_CUSTOM_EVENT.REMOVE_ITEMS_GROUP]: void;
  [E_MIDDLEWARE_STEPS.CHANGE]: string;
  [E_MIDDLEWARE_STEPS.RESULT]: boolean;
  [E_TO_STEP_CUSTOM_EVENT.LOAD_START]: string;
  [E_TO_STEP_CUSTOM_EVENT.LOAD_END]: string;
  [E_MODAL_CUSTOM_EVENT.CLOSE_GUIDE]: void;
  [E_EDITOR_CUSTOM_EVENT.EDIT_ITEM_TEXT]: { itemName: string, itemText: string }
};

const emitter = mitt<TEmitterEvents>();

emitter.on(E_MIDDLEWARE_STEPS.CHANGE, (to) => {
  ExecutionDelay.add(E_MIDDLEWARE_STEPS.CHANGE, () => stepsMiddleware.onChangeEmit(to), 500);
});

export default emitter;